<template>
  <div>
  <div style="margin-bottom:66px">
  <nav class="navbar bg-light navbar-light fixed-top shadow-sm">
    <div class="container">
    <a class="navbar-brand d-flex align-items-center" href="/">
      <img class="d-inline-block align-top" width="36" height="auto" src="data:image/svg+xml;utf8;base64,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" />
      <div class="pl-3"> 
        <h1 class="h5 mb-0 text-">Islami.app<span class="d-none d-sm-inline"> إسلامي</span><small> &nbsp;<sup class="badge badge-danger">Beta</sup></small></h1>
        <h2 class="h6 mb-0"><small class="text-muted">{{hijri}}<span class="d-none d-sm-inline"> / {{ date }}, {{ time }}</span></small></h2>
      </div>
    </a>
    <!-- <a class="d-inline-block" href='#' id='example' rel='popover' data-trigger="focus"  data-placement='right' data-content='Its so simple to create a tooltop for my website!'>
      HEY
    </a> -->

    <div class="btn-group btn-group-sm  text-primary" role="group" aria-label="Second group">
      <button class="btn btn-secondary text-white" data-toggle="modal" data-target="#hijri-settings">
        <i class="fas fa-cog"></i>
      </button>
    </div>

    
    </div>
  </nav>
  </div>
  <modal ref="settings" id="hijri-settings">
    <h5 slot="header"><i class="fas fa-cog"></i> Settings</h5>
    <app-settings></app-settings>
  </modal>
  <div v-if="!position || !settings.confirmed" class="alert p-2 pr-4 alert-secondary text-center rounded-0 rounded-bottom">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    
    <template v-if="!position">
    <p class="text-danger mb-1"><i class="fas fa-exclamation-triangle"></i> Unable to detect your location.  Location info is needed to calculate prayer times.</p>
    <p class="mb-2"><button class="btn btn-sm btn-outline-dark mr-2" @click.prevent="$store.dispatch('locate');">Detect Location</button>
      <button class="btn btn-sm btn-outline-dark" data-toggle="modal" data-target="#hijri-settings" @click="onConfirmed">Manually update Settings</button></p>
    </template>

    <template v-if="!settings.confirmed && position" class="text-muted mb-0">
     <p class="mb-1"><small><i class="fas fa-question-circle"></i> &nbsp;<b>Confirm Settings</b>&nbsp; <u>Calculation</u>: {{ settings.method }}, <u>Asr timing</u>: {{ settings.asr }}</small></p>
      <p class="mb-0">
        <button class="btn btn-sm btn-outline-secondary mr-2" @click="onConfirmed">OK</button>  
        <button class="btn btn-sm btn-outline-secondary" data-toggle="modal" data-target="#hijri-settings" @click="onConfirmed">Update Settings</button>
      </p>
    </template>


    <div>
    </div>
    
  </div>
  </div>
</template>


<script>
import Widget from "@/Widget";
import Modal from '@/Modal';
import AppSettings from '@/AppSettings';
import moment from 'moment';
import hijri from "moment-hijri";
import jQuery from 'jquery';

moment.locale('en');
export default {
  components: {
    Widget, Modal, AppSettings
  },

  computed: {
    settings() {
      return this.$store.getters.settings;
    },

    position() {
      return this.$store.getters.location;
    },

    currentTime() {
      return this.$store.state.time;
    },

    hijri() {
      let correction  = 0;
      if(this.settings.hijriCorrection) {
        correction = parseInt(this.settings.hijriCorrection);
      }
     
      let date =  hijri(this.currentTime);
      date.add(correction, 'days');
      return date.format("iMMMM iD iYYYY");
    },

    date() {
      return moment(this.currentTime).format('LL');
    },

    time() {
      return moment(this.currentTime).format('LT')
    },
  },

  mounted() {
    console.log('app mounted');
     jQuery("#example").popover({trigger: 'focus'});
    //  jQuery('#example').popover('show');
  },

  methods: {
    onConfirmed() {
      console.log('confirming');
      this.$store.commit('settings', {...this.$store.getters.settings, confirmed: true});
    }
  }
};
</script>


<style scoped>
  .h5 {
    font-size:.8em;
  }

  sup.badge {
    line-height: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/lib/ui/AppBar.vue